import Overview from './views/Overview'
import Module from './views/Module'
import Actions from './views/Actions'
import Action from './views/Action'
import Properties from './views/Properties'
import Entities from './views/Entities'
import Entity from './views/Entity'
import EntityProperty from './views/Entityproperty'
import EntityPropertyValues from './views/EntityPropertyValues'


export default {
    routes: [
      {path: '/module/module', name: 'Overview', component: Overview, meta: {setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code', name: 'Module', component: Module, meta: {setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code/actions', name: 'Actions', component: Actions, meta: {tab: 'actions', setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code/actions/:action_code', name: 'Action', components: {right: Action, default: Actions}, meta: {tab: 'actions', setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code/properties', name: 'Properties', component: Properties, meta: {tab: 'properties', setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code/entities', name: 'Entities', component: Entities, meta: {tab: 'entities', setting_link: 'ModulesOverview'}},
      {path: '/module/module/:code/entities/:entity_code', name: 'Entity', component: Entity, meta: {tab: 'entities', setting_link: 'ModulesOverview'}},
      {
        path: '/module/module/:code/entities/:entity_code/:entity_prop_code',
        name: 'EntityProperty',
        components: {right: EntityProperty, default: Entity},
        meta: {tab: 'entities', setting_link: 'ModulesOverview'}
      },
      {
        path: '/module/module/:code/entities/:entity_code/new',
        name: 'NewEntityProperty',
        components: {right: EntityProperty, default: Entity},
        meta: {tab: 'entities', setting_link: 'ModulesOverview'}
      },


      {
        path: '/module/module/:code/entities/:entity_code/:entity_prop_code/values',
        name: 'EntityPropertyValues',
        components: {right: EntityPropertyValues, default: Entity},
        meta:{tab: 'entities', setting_link: 'ModulesOverview'}
      },
    ]
}



// WEBPACK FOOTER //
// ./src/modules/module/routes.js